import t from '@jetshop/intl';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import ActiveListFilters from '@jetshop/ui/Filter/ActiveFilters';
import BoolFilters from '@jetshop/ui/Filter/FilterTypes/BoolFilters';
// import ListFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/List/ListFilterFlyouts';
import ListFilterFlyouts from './ListFilterFlyoutsCustom';
import MultiListFlyouts from '@jetshop/ui/Filter/FilterTypes/Multi/MultiListFlyouts';
//import RangeFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/Range/RangeFilterFlyouts';
import RangeFilterFlyouts from './Range/RangeFilterFlyouts';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
//import SortOrderDropdown from '@jetshop/ui/SortOrder/SortOrderDropdown';
//import { ReactComponent as Carrot } from '@jetshop/ui/svg/Carrot.svg';
import theme from '@jetshop/ui/utils/theme';
//import get from 'lodash.get';
import React, { Component, Fragment } from 'react';
import styled from 'react-emotion';
import FilterDrawer from './FilterDrawer';
import { ReactComponent as FilterIconSVG } from '../../../svg/Filter.svg';

const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: ${theme('space.2')};
  // button:first-of-type {
  //   margin-right: ${theme('space.1')};
  // }
  ${theme('above.sm')} {
    padding: ${theme('space.1')};
  }
  // svg {
  //   transform: rotate(-90deg);
  // }
`;

const MobileButton = styled('button')`
  height: 48px;
  width: 100%;
  display: table-cell;
  background: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.black};
  cursor: pointer;
  text-align: center;
  padding: ${theme('space.1')};
  font-weight: ${theme('fontWeights.semibold')};
  color: #fff;
  svg {
    margin-left: 1rem;
    width: 1.1rem;
    height: 1.1rem;
  }
  > * {
    display: inline-block;
    margin: 0 0.5rem;
    vertical-align: middle;
  }
`;

const FilterHead = styled('div')`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyMediumDark};
  display: none;
  & > aside {
    margin: 0;
    & > div {
      display: none;
    }
    & > button {
      background: none;
      margin: 0;
      margin-right: ${({ theme }) => theme.sizes.gap};
      text-decoration: none;
      color: ${({ theme }) => theme.colors.black} !important;
    }
  }
`;

const FilterHeading = styled('h3')`
  font-size: 1.25rem;
  padding: 0.8rem 0;
  padding-left: ${({ theme }) => theme.sizes.gap};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.sansSerif};
  margin-bottom: 0;
`;

const Filters = styled('div')`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  //grid-auto-columns: minmax(200px, 500px);
  //grid-auto-flow: column;
  grid-gap: 8px;
  margin-bottom: 0.5rem;

  ${theme('above.md')} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${theme('above.lg')} {
    grid-template-columns: repeat(5, 1fr);
  }

  > button {
  }

  p {
    line-height: 1.3;
    margin: 0 0 0 1rem;
    text-align: left;

    + p {
      margin: 0 5px;
    }
  }

  & > div[class*='Storlek'] {
    & > div {
      & > div {
        display: flex;
        flex-wrap: wrap;
        padding: 5px;
        margin: 0 auto;
        background: ${({ theme }) => theme.colors.lightgrey};

        & > button {
          display: inline-block;
          flex: 0 1 23%;
          height: 32px;
          position: relative;
          margin: 0 1% 2% 1%;
          background: #fff;
          border: none;

          &:hover {
            background: #eee;
          }

          &:disabled {
            opacity: 0.4;
          }
          & > svg {
            display: block;
            width: 100%;
            height: 32px;
            background: #aaa;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            stroke: transparent !important;
            use {
              fill: transparent !important;
            }
          }
          & > span {
            height: 32px;
            position: relative;
            color: #000;
            z-index: 2;
            align-items: center;
            & > p:first-of-type {
              margin: 0 auto;
            }
            & > p:last-of-type {
              display: none;
            }
          }
        }
      }
    }
  }
`;

const FilterIcon = styled(FilterIconSVG)`
  fill: #fff;
`;

class Filter extends Component {
  render() {
    const { filters } = this.props;
    //const sortOrders = get(this, 'props.sortOrders', []);
    let filterSizeDesign = filters;
    /*filterSizeDesign.map(filter => {
      if (filter.name === 'Storlek') {
        return (filter['className'] = 'sizeFilterClass StyledSelectDropdown');
      } else {
        return (filter['className'] = 'StyledSelectDropdown');
      }
    });*/

    return (
      <Fragment>
        <Above
          breakpoint="sm"
          render={() => (
            <Fragment>
              <Filters className={'Filters'}>
                <FilterHead>
                  <FilterHeading>{t('Filter')}</FilterHeading>
                  <ActiveListFilters filters={filters} />
                </FilterHead>
                <ListFilterFlyouts filters={filterSizeDesign} />
                <RangeFilterFlyouts filters={filters} />
                {/*
                  {sortOrders.length > 0 && (
                    <SortOrderDropdown sortOrders={sortOrders} />
                  )}
                */}
              </Filters>
              <Filters>
                <MultiListFlyouts
                  filters={filters}
                  result={this.props.result}
                />
                <div
                  css={{
                    marginLeft: 'auto',
                    marginRight: '8px'
                  }}
                >
                  <BoolFilters filters={filters} />
                </div>
              </Filters>
            </Fragment>
          )}
        />
        <Below
          breakpoint="sm"
          render={() => {
            return (
              <Fragment>
                <ButtonWrapper>
                  <DrawerTrigger id="filterDrawer" showCover={false}>
                    {({ showTarget }) => (
                      <MobileButton onClick={showTarget}>
                        <p>{t('Filter')}</p>
                        <FilterIcon />
                      </MobileButton>
                    )}
                  </DrawerTrigger>

                  {/*
                  {sortOrders.length > 0 && (
                    <DrawerTrigger id="sortDrawer">
                      {({ showTarget }) => (
                        <MobileButton onClick={showTarget}>
                          <p>{t('Sort By')}</p>
                          <Carrot />
                        </MobileButton>
                      )}
                    </DrawerTrigger>
                  )}
                  */}
                </ButtonWrapper>
                <DrawerTarget id="filterDrawer">
                  {({ hideTarget, isOpen }) => (
                    <Drawer size="515" isOpen={isOpen} right>
                      <FilterDrawer close={hideTarget} filters={filters} />
                    </Drawer>
                  )}
                </DrawerTarget>

                {/*
                {sortOrders.length > 0 && (
                  <DrawerTarget id="sortDrawer">
                    {({ hideTarget, isOpen }) => (
                      <Drawer isOpen={isOpen} right>
                        <FilterDrawer
                          close={hideTarget}
                          sortOrders={sortOrders}
                        />
                      </Drawer>
                    )}
                  </DrawerTarget>
                )}
                */}
              </Fragment>
            );
          }}
        />
      </Fragment>
    );
  }
}

export default Filter;
